import WaterfallFlow from "@/components/Exercises/Waterfall/WaterfallFlow";
import { Button } from "@/components/ui/button";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import MediaPlayer from "@/components/ui/media-player";
import waterfallAudio from "@/assets/audios/source-of-strength-waterfall.m4a";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/waterfall/",
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Sources of Strength: Waterfall - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "waterfall.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const [showOverlay, setShowOverlay] = useState(false);
  const [isPausedAudio, setIsPausedAudio] = useState(false);

  const startExercise = () => {
    setIsPausedAudio(true);
    setShowOverlay(true);
  };

  const closeOverlay = () => {
    setShowOverlay(false);
    setIsPausedAudio(false);
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={startExercise}>
          <FormattedMessage id="common.startExercise" />
        </Button>
      }
    >
      <p className="text-small text-dark">
        <FormattedMessage id="waterfall.intro" />
      </p>
      <MediaPlayer
        src={waterfallAudio}
        segment={{ start: 0, end: 38 }}
        isPaused={isPausedAudio}
      />
      <WaterfallFlow
        isShow={showOverlay}
        onComplete={closeOverlay}
        onExit={closeOverlay}
      />
    </ExerciseLayout>
  );
}
